export default "__VITE_ASSET__Dl56minx__"